import React, { forwardRef, useState } from "react";
import {
  InputAccessoryView,
  View,
  TouchableOpacity,
  StyleSheet,
  Image,
  Keyboard,
} from "react-native";
import { useTheme } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
import { Text } from "../../components/text/text";

interface InputAccessoryNavigationProps {
  inputAccessoryViewID: string;
  currentInputIndex: number;
}

export const InputAccessoryNavigation = forwardRef(
  (props: InputAccessoryNavigationProps, ref: any) => {
    const theme = useTheme() as ThemeType;
    const { inputAccessoryViewID, currentInputIndex } = props;
    const nextDisabled = currentInputIndex == ref.length - 1;
    const previousDisabled = currentInputIndex == 0;
    const arrowsHidden = ref.length == 1;
    const styles = getStyles(theme, nextDisabled, previousDisabled);

    const onPrevious = () => {
      if (currentInputIndex > 0) {
        const previous = ref[currentInputIndex - 1].current;
        if (previous.root && previous.root._inputElement && previous.root._inputElement.focus) {
          //In case of TextInputMask this gives us a reference to TextInput
          previous.root._inputElement.focus();
        } else {
          previous.focus();
        }
      }
    };

    const onNext = () => {
      if (currentInputIndex < ref.length - 1) {
        const next = ref[currentInputIndex + 1].current;
        // *iOS only fix*
        // there is a case where ref[7].current does not have the focus function avaliable
        // so as a work around we will check to see if ref.current is null
        // the state/provice dropdown will not focus if it is not avaliable
        // not the best fix but will fix the crash in ENG-1721
        if (next) {
          if (next.root && next.root._inputElement && next.root._inputElement.focus) {
            //In case of TextInputMask this gives us a reference to TextInput
            next.root._inputElement.focus();
          } else {
            next.focus();
          }
        }
      }
    };

    const onDone = () => {
      Keyboard.dismiss();
    };

    return (
      <InputAccessoryView nativeID={inputAccessoryViewID}>
        <View style={styles.accessoryContainer}>
          {!arrowsHidden ? (
            <View style={styles.leftContainer}>
              <TouchableOpacity
                style={styles.previousNextButton}
                onPress={onPrevious}
                disabled={previousDisabled}>
                <Image
                  style={styles.arrowPrevious}
                  source={require("../../../assets/arrow-down.png")}
                />
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.previousNextButton}
                onPress={onNext}
                disabled={nextDisabled}>
                <Image
                  style={styles.arrowNext}
                  source={require("../../../assets/arrow-down.png")}
                />
              </TouchableOpacity>
            </View>
          ) : (
            <View style={styles.leftContainer} />
          )}
          <TouchableOpacity onPress={onDone}>
            <Text style={styles.doneButtonText}>Done</Text>
          </TouchableOpacity>
        </View>
      </InputAccessoryView>
    );
  }
);

const getStyles = (theme: ThemeType, nextDisabled: boolean, previousDisabled: boolean) => {
  const { colors, fontSize, spacing } = theme;
  return StyleSheet.create({
    accessoryContainer: {
      height: spacing.huge,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: spacing.medium,
      paddingRight: spacing.medium,
      backgroundColor: colors.lightGrey,
    },
    leftContainer: {
      flexDirection: "row",
      alignItems: "center",
    },
    previousNextButton: {
      marginRight: spacing.large,
    },
    doneButtonText: {
      fontWeight: "500",
      fontSize: fontSize.large,
      color: colors.inputNavigation,
    },
    arrowPrevious: {
      tintColor: previousDisabled ? colors.darkGrey : colors.inputNavigation,
      transform: [{ rotate: "180deg" }],
      width: spacing.large,
      height: spacing.large,
      resizeMode: "contain",
    },
    arrowNext: {
      tintColor: nextDisabled ? colors.darkGrey : colors.inputNavigation,
      width: spacing.large,
      height: spacing.large,
      resizeMode: "contain",
    },
  });
};
